module.exports = __webpack_public_path__ + "img/V-R-6-unload-connect-shadow.777c3b4f.png";